import { createContext, useState, useEffect } from "react";

export const BasketContext = createContext();

const BasketContextProvider = ({ children }) => {
  const [basketIsOpen, setBasketIsOpen] = useState(false);
  const [basketItems, setBasketItems] = useState([]);
  const [basketTotal, setBasketTotal] = useState(0);
  const [currentQuantity, setCurrentQuantity] = useState(1);
  const [itemStocks, setItemStocks] = useState({});

  // Effect to update the total when basketItems change
  useEffect(() => {
    const total = basketItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
    setBasketTotal(total);
  }, [basketItems]); // Recalculate total when items change

  const values = {
    basketIsOpen,
    setBasketIsOpen,
    basketItems,
    setBasketItems,
    basketTotal,
    setBasketTotal,
    currentQuantity,
    setCurrentQuantity,
    itemStocks,
    setItemStocks,
  };

  return <BasketContext.Provider value={values}>{children}</BasketContext.Provider>;
};

export default BasketContextProvider;